import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	IconButton,
	TableRow,
	TableCell,
	Menu,
	MenuItem,
	Checkbox,
	Typography
} from '@mui/material';
import { Image } from 'components';
import { MoreHoriz, Check } from '@mui/icons-material';

const TrainerItem = ({
	trainer,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(trainer, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(trainer, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(trainer.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(trainer)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected}
						onChange={() => handleSelect(trainer)}
						name="trainer"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={trainer.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{trainer.first_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{trainer.last_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="primary.text"
					color={trainer.featured ? 'success.main' : 'text.secondary'}
				>
					{trainer.featured ? <Check /> : '-'}
				</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default TrainerItem;
